export default "__VITE_ASSET__DDnCmS7k__"